@use '~/theme/theme' as *;

.container {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.indicatorContainer {
  flex-shrink: 0;
  width: 32px;
  height: 20px;
  border-radius: 40px;
  background-color: color(grey-500);
  display: flex;
  align-items: center;
  transition:
    background-color 300ms,
    color 300ms;
}

.indicator {
  margin: 2px;
  background: white;
  border-radius: 16px;
  transition:
    background-color 300ms,
    margin-left 300ms,
    color 300ms;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
}

.custom .indicatorContainer {
  background-color: color(orange-700);

  .indicator {
    color: color(orange-800);
  }
}

.innerContainer {
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;

  &[data-disabled] {
    cursor: default;

    .indicatorContainer {
      opacity: 0.5;
    }
  }

  &[data-selected] {
    .indicatorContainer {
      background-color: color(violet-600);
    }

    .indicator {
      margin-left: 14px;
    }
  }

  &[data-focus-visible] {
    .indicatorContainer {
      outline: 2px solid color(violet-600);
      outline-offset: 2px;
    }
  }
}

.custom[data-selected] .indicatorContainer {
  background-color: color(green-700);

  .indicator {
    color: color(forest-700);
  }
}
